/**
 * SMOOTH_SCROLL モジュール
 * - hrefが "#anc" で始まるリンクをクリックした際にスムーズスクロールを実行
 */
export const SMOOTH_SCROLL = {
  init() {
    const elements = document.querySelectorAll('a[href^="#anc"]')

    elements.forEach(el => {
      el.addEventListener('click', event => {
        event.preventDefault()

        const href = el.getAttribute('href')
        const target = document.querySelector(href)

        if (target) {
          const top = target.getBoundingClientRect().top + window.pageYOffset

          // スムーズスクロールを実行
          window.scrollTo({
            top,
            behavior: 'smooth',
          })

          // 擬似的なスクロールイベントを一定時間後にトリガー（jQueryの trigger('scroll') 代替）
          setTimeout(() => {
            window.dispatchEvent(new Event('scroll'))
          }, 600) // 500msのスクロール＋余裕
        }
      })
    })
  },
}
